// src/services/favourite.service.js
import { auth } from "../config/firebase"; // Adjust this path if your firebase config is located elsewhere

// Change this to match your actual backend URL or use your environment variable
const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5172/api";

/**
 * Helper function to grab the current user's Firebase token
 */
const getAuthToken = async () => {
  const user = auth.currentUser;
  if (user) {
    // Pass true to force refresh if it's expired
    return await user.getIdToken(true);
  }
  return null;
};

const favouriteService = {
  /**
   * 1. Get all favourites for the logged-in user
   */
  getFavourites: async () => {
    try {
      const token = await getAuthToken();
      if (!token) {
        // If not logged in, return an empty array instead of crashing
        return [];
      }

      const response = await fetch(`${API_BASE_URL}/favourites`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch favourites");

      const data = await response.json();
      return data; // Returns the formatted array from your backend controller
    } catch (error) {
      console.error("Service Error - getFavourites:", error);
      return [];
    }
  },

  /**
   * 2. Add a product to favourites
   */
  addFavourite: async (productId) => {
    try {
      const token = await getAuthToken();
      if (!token) {
        return { error: "notLoggedIn" };
      }

      const response = await fetch(`${API_BASE_URL}/favourites/add`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ product_id: productId }),
      });

      if (!response.ok) throw new Error("Failed to add favourite");

      return await response.json();
    } catch (error) {
      console.error("Service Error - addFavourite:", error);
      throw error;
    }
  },

  /**
   * 3. Remove a product from favourites
   */
  removeFavourite: async (productId) => {
    try {
      const token = await getAuthToken();
      if (!token) return { error: "notLoggedIn" };

      const response = await fetch(
        `${API_BASE_URL}/favourites/remove/${productId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) throw new Error("Failed to remove favourite");

      return await response.json();
    } catch (error) {
      console.error("Service Error - removeFavourite:", error);
      throw error;
    }
  },
};

export default favouriteService;
